<template>
  <v-container fluid class="pa-0">
    <Headline3 title="Impresszum"
               subtitle=" "
               :background-top-color="$PRIMARY_COLOR"
               :background-bottom-color="$SECONDARY_COLOR"/>
    <SpaceHorizontal :height="5"/>
    <div class="text-center">
      <div>
        A Vállalkozás neve:
      </div>
      <div class="text-h6 mb-4">
        TMX Mobile Solution Szerviz Szolgáltató Korlátolt Felelősségű Társaság
      </div>
      <div>
        A Vállalkozás székhelye:
      </div>
      <div class="text-h6 mb-4">
        2040 Budaörs, Kinizsi utca 2/B.
      </div>
      <div>
        A Vállalkozás fióktelepei:
      </div>
      <div class="text-h6 mb-4">
        1085 Budapest, József körút 17. fszt. 2., 5465 Cserkeszőlő, Fürdő utca 16.
      </div>
      <div>
        A Vállalkozás postai címe:
      </div>
      <div class="text-h6 mb-4">
        2040 Budaörs, Kinizsi utca 2/B.
      </div>
      <div>
        A Vállalkozás telefonszáma:
      </div>
      <div class="text-h6 mb-4">
        +36-1/585-8381
      </div>
      <div>
        A Vállalkozás telefax száma:
      </div>
      <div class="text-h6 mb-4">
        +36-23/801-706
      </div>
      <div>
        A Vállalkozás elektronikus levelezési címe:
      </div>
      <div class="text-h6 mb-4">
        info@tmx.hu
      </div>
      <div>
        A Vállalkozás közösségiadószáma:
      </div>
      <div class="text-h6 mb-4">
        HU23059940
      </div>
      <div>
        A Weboldal tárhelyszolgáltatójának neve és adatai:
      </div>
      <div class="text-h6">
        TMX Mobile Solution Szerviz Szolgáltató Korlátolt Felelősségű Társaság
      </div>
      <div>
        Székhely: 2040 Budaörs, Kinizsi utca 2/B.
      </div>
    </div>
    <SpaceHorizontal :height="5"/>
  </v-container>
</template>

<script>
import Headline3 from 'src/components/headlines/Headline3.vue';
import SpaceHorizontal from 'src/components/general/SpaceHorizontal.vue';

export default {
  name: 'ImprintPage',
  components: {
    Headline3, SpaceHorizontal,
  },
  props: {
    //
  },
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
